import { FEATURE_FLAGS } from 'dashboard/featureFlags';

// Captain vale na versão antiga (captain_integration) ou na V2
// (captain_integration_v2), que é a que as contas usam hoje.
export const CAPTAIN_FLAGS = [FEATURE_FLAGS.CAPTAIN, FEATURE_FLAGS.CAPTAIN_V2];

// Dependência em lista vale se qualquer uma das flags estiver ligada.
export const isDependencyEnabled = (dependency, isEnabled) => {
  if (!dependency) return true;
  if (Array.isArray(dependency)) return dependency.some(isEnabled);
  return isEnabled(dependency);
};

// `dependency`: módulo nativo sem o qual a aba não tem o que mostrar
// (Copilot depende do Captain; Ligações, do módulo de telefonia).
export const AI_CENTER_MODULES = [
  { id: 'kanban', icon: 'i-ph-kanban', flag: FEATURE_FLAGS.AI_CENTER_KANBAN },
  {
    id: 'social',
    icon: 'i-ph-instagram-logo',
    flag: FEATURE_FLAGS.AI_CENTER_SOCIAL,
  },
  {
    id: 'opportunities',
    icon: 'i-ph-target',
    flag: FEATURE_FLAGS.AI_CENTER_OPPORTUNITIES,
  },
  {
    id: 'conversions',
    icon: 'i-ph-chart-line-up',
    flag: FEATURE_FLAGS.AI_CENTER_CONVERSIONS,
  },
  {
    id: 'properties',
    icon: 'i-ph-house-line',
    flag: FEATURE_FLAGS.REAL_ESTATE_MODULE,
  },
  {
    id: 'calls',
    icon: 'i-ph-phone-call',
    flag: FEATURE_FLAGS.AI_CENTER_CALLS,
    dependency: FEATURE_FLAGS.VOIP_CALLS,
  },
  {
    id: 'copilot',
    icon: 'i-ph-sparkle',
    flag: FEATURE_FLAGS.AI_CENTER_COPILOT,
    dependency: CAPTAIN_FLAGS,
  },
  // Fila de revisão dos reports das respostas da IA: vale para toda conta com
  // Captain (antigo ou V2); só administrador vê (adminOnly).
  {
    id: 'reports',
    icon: 'i-ph-flag',
    flag: FEATURE_FLAGS.AI_ACTION_CENTER,
    dependency: CAPTAIN_FLAGS,
    adminOnly: true,
  },
].map(module => ({
  ...module,
  label: `AI_CENTER.TABS.${module.id.toUpperCase()}`,
}));

export const isAiCenterModuleEnabled = (id, isEnabled) => {
  if (!isEnabled(FEATURE_FLAGS.AI_ACTION_CENTER)) return false;
  const module = AI_CENTER_MODULES.find(item => item.id === id);
  if (!module || !isEnabled(module.flag)) return false;
  return isDependencyEnabled(module.dependency, isEnabled);
};
